"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Integrations API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsServiceApi = exports.IntegrationsServiceApiFactory = exports.IntegrationsServiceApiFp = exports.IntegrationsServiceApiFetchParamCreator = exports.IntegrationsDropboxStatus = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
const url = __importStar(require("url"));
const portableFetch = __importStar(require("portable-fetch"));
const BASE_PATH = "https://develop-api.resideadmissions.com/".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 *
 * @export
 * @enum {string}
 */
var IntegrationsDropboxStatus;
(function (IntegrationsDropboxStatus) {
    IntegrationsDropboxStatus["OFF"] = "DROPBOX_STATUS_OFF";
    IntegrationsDropboxStatus["ON"] = "DROPBOX_STATUS_ON";
})(IntegrationsDropboxStatus = exports.IntegrationsDropboxStatus || (exports.IntegrationsDropboxStatus = {}));
/**
 * IntegrationsServiceApi - fetch parameter creator
 * @export
 */
exports.IntegrationsServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Removes the related dropbox token from the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteDropboxToken(options = {}) {
            const localVarPath = `/api/integrations/dropbox/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options = {}) {
            const localVarPath = `/api/integrations/quicksight/cache`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options = {}) {
            const localVarPath = `/api/integrations/quicksight/admin/dashboards`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboard(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling integrationsServiceGetDashboard.');
            }
            const localVarPath = `/api/integrations/quicksight/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options = {}) {
            const localVarPath = `/api/integrations/quicksight/dashboards`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling integrationsServiceGetDashboardsUser.');
            }
            const localVarPath = `/api/integrations/quicksight/admin/dashboards/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns on/off when organization has connection to Dropbox
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxStatus(options = {}) {
            const localVarPath = `/api/integrations/dropbox/status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the authorization URL for the front end to visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxURL(options = {}) {
            const localVarPath = `/api/integrations/dropbox/url`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options = {}) {
            const localVarPath = `/api/integrations/health`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId the user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling integrationsServicePostDashboard.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling integrationsServicePostDashboard.');
            }
            const localVarPath = `/api/integrations/quicksight/users/{userId}/dashboards`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IntegrationsPostDashboardInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Exchanges the users auth code for access token
         * @param {IntegrationsPostDropboxTokenInput} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDropboxToken(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling integrationsServicePostDropboxToken.');
            }
            const localVarPath = `/api/integrations/dropbox/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IntegrationsPostDropboxTokenInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IntegrationsServiceApi - functional programming interface
 * @export
 */
exports.IntegrationsServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Removes the related dropbox token from the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteDropboxToken(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceDeleteDropboxToken(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceDeleteQuickSightCache(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetAdminDashboards(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboard(id, options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboard(id, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboards(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboardsUser(userId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns on/off when organization has connection to Dropbox
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxStatus(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDropboxStatus(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns the authorization URL for the front end to visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxURL(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDropboxURL(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetHealth(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId the user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServicePostDashboard(body, userId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Exchanges the users auth code for access token
         * @param {IntegrationsPostDropboxTokenInput} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDropboxToken(body, options) {
            const localVarFetchArgs = exports.IntegrationsServiceApiFetchParamCreator(configuration).integrationsServicePostDropboxToken(body, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * IntegrationsServiceApi - factory interface
 * @export
 */
exports.IntegrationsServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Removes the related dropbox token from the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteDropboxToken(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceDeleteDropboxToken(options)(fetch, basePath);
        },
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceDeleteQuickSightCache(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetAdminDashboards(options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboard(id, options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboard(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboards(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboardsUser(userId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns on/off when organization has connection to Dropbox
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxStatus(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetDropboxStatus(options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns the authorization URL for the front end to visit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDropboxURL(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetDropboxURL(options)(fetch, basePath);
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServiceGetHealth(options)(fetch, basePath);
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId the user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServicePostDashboard(body, userId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Exchanges the users auth code for access token
         * @param {IntegrationsPostDropboxTokenInput} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDropboxToken(body, options) {
            return exports.IntegrationsServiceApiFp(configuration).integrationsServicePostDropboxToken(body, options)(fetch, basePath);
        },
    };
};
/**
 * IntegrationsServiceApi - object-oriented interface
 * @export
 * @class IntegrationsServiceApi
 * @extends {BaseAPI}
 */
class IntegrationsServiceApi extends BaseAPI {
    /**
     *
     * @summary Removes the related dropbox token from the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceDeleteDropboxToken(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceDeleteDropboxToken(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Removes all QuickSight cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceDeleteQuickSightCache(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceDeleteQuickSightCache(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieves all visible dashboards from quicksight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetAdminDashboards(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetAdminDashboards(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns an embedded url which renders a dashboard
     * @param {string} id the dashboard_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboard(id, options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboard(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrives the dashboards the connected user can access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboards(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboards(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieves the dashboards visible for one given user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboardsUser(userId, options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboardsUser(userId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns on/off when organization has connection to Dropbox
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDropboxStatus(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDropboxStatus(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns the authorization URL for the front end to visit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDropboxURL(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDropboxURL(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Checks service is up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetHealth(options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServiceGetHealth(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Grants and revokes permissions to a dashboard for a given user
     * @param {IntegrationsPostDashboardInput} body
     * @param {string} userId the user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServicePostDashboard(body, userId, options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServicePostDashboard(body, userId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Exchanges the users auth code for access token
     * @param {IntegrationsPostDropboxTokenInput} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServicePostDropboxToken(body, options) {
        return exports.IntegrationsServiceApiFp(this.configuration).integrationsServicePostDropboxToken(body, options)(this.fetch, this.basePath);
    }
}
exports.IntegrationsServiceApi = IntegrationsServiceApi;
